import React from "react";
import Sidebar from "./sidebar";

const SkeletonUILoader = () => {
  return (
    <>
      <section className="container mtopcon dashb">
          <div className="row">
            <div className="col-12 col-lg-2 dash-min mb-3">
              <div className="nav-left-sidebar sidebar-dark pc">
                <div className="slimScrollDiv">
                  <div className="menu-list">
                    <nav className="navbar navbar-expand-lg navbar-light nav-l-con">
                      <div className="collapse navbar-collapse" id="navbarNav">
                        <Sidebar />
                      </div>
                    </nav>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-10 dash-max">
                <style>
                  {`
                    @keyframes kadhrShimmer {
                      0% {
                        background-position: -500px 0;
                      }
                      100% {
                        background-position: 500px 0;
                      }
                    }

                    .kadhr-skeleton {
                      background: linear-gradient(
                        90deg,
                        #f3f4f6 25%,
                        #ffffff 50%,
                        #f3f4f6 75%
                      );
                      background-size: 1000px 100%;
                      animation: kadhrShimmer 1.4s infinite linear;
                    }
                  `}
                </style>

                <div className="mt-1">
                  {/* headline */}
                  <div
                    className="kadhr-skeleton mb-3"
                    style={{
                      height: "16px",
                      width: "55%",
                      borderRadius: "10px",
                    }}
                  />

                  {/* main metric */}
                  <div
                    className="kadhr-skeleton mb-4"
                    style={{
                      height: "42px",
                      width: "65%",
                      borderRadius: "12px",
                    }}
                  />

                  {/* progress bar */}
                  <div
                    className="kadhr-skeleton mb-3"
                    style={{
                      height: "14px",
                      width: "100%",
                      borderRadius: "999px",
                    }}
                  />

                  {/* chips */}
                  <div className="d-flex gap-2 flex-wrap mb-4">
                    {[1, 2, 3, 4].map((item) => (
                      <div
                        key={item}
                        className="kadhr-skeleton"
                        style={{
                          height: "28px",
                          width: "90px",
                          borderRadius: "999px",
                        }}
                      />
                    ))}
                  </div>

                  {/* CTA */}
                  <div
                    className="kadhr-skeleton"
                    style={{
                      height: "42px",
                      width: "100%",
                      borderRadius: "12px",
                    }}
                  />
                </div>
            </div>
          </div>
          
        </section>
    </>
  );
};

export default SkeletonUILoader;